<template>
    <div class="page" v-if="washDetailsVisible">
        <div class="comp-title">
            <span>订单详情</span>
            <el-button icon="el-icon-close" circle @click="close"></el-button>
        </div>
        <div class="content">
            <div class="order-info">
                <div class="info-item">订单编号：<span>{{ order.orderNumber }}</span></div>
                <div class="info-item">收件编码：<span>{{ order.receiveCode }}</span></div>
                <div class="info-item">下单时间：<span>{{ order.orderAddtime }}</span></div>
                <div class="info-item">付款时间：<span>{{ order.orderPaytime }}</span></div>
                <div class="info-item">是否支付: <span>{{ order.orderPaytime ? "未支付" : "已支付" }}</span></div>
                <div class="info-item">订单状态: <span>{{ orderStatusStoreEnumList.find(item => item.key === order.orderStatus).value }}</span></div>
                <div class="info-item">商品名称：<span>{{ order.shopOrderSkuList.map(item=>item.shopProduct.productName).join("|") }}</span></div>
                <div class="info-item">商品数量：<span>{{ order.orderSize }}</span></div>
                <div class="info-item">实付金额：<span>{{ order.actualPrice }}</span></div>
                <div class="info-item-remarks">订单备注：<span>{{ order.orderRemarks }}</span></div>

                <div class="fahuo-btn">
                    <el-button v-if="order.orderStatus > 4" size="medium" type="primary" @click="enterInfo">继续录入</el-button>
                    <el-button v-if="order.orderStatus > 4" size="medium" type="primary" @click="printKuaiDi()">{{ order.orderStatus === 5 ? "打印发货单" : "补打发货单"}}</el-button>
                </div>
            </div>

            <div class="other-info">
                <div>
                    <span class="copy-btn" @click="cpoyInfo(`${order.orderContact},${order.orderTel},${order.orderAddress}`)">复制</span>
                    <strong><h5>门店信息</h5></strong>
                    <span>{{ order.store.storeName }}</span>
                    <span>{{ order.orderContact }},{{ order.orderTel }},{{ order.orderAddress }}</span>
                </div>
                <div>
                    <span class="copy-btn" @click="cpoyInfo(`${order.user.userNickname},${order.user.userMobile}`)">复制</span>
                    <strong><h5>客户信息</h5></strong>
                    <span>{{ order.user.userNickname }},{{ order.user.userMobile }}</span>
                </div>
            </div>

            <div class="table-info">
                <el-table
                    :data="washOrderitemList"
                    height="100%"
                    size="small"
                    border
                    style="width: 100%;margin-top: 2px;font-size: 16px"
                >
                    <el-table-column
                        prop="seq"
                        align="center"
                        width="60px"
                        show-overflow-tooltip
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="productName"
                        align="center"
                        show-overflow-tooltip
                        label="名称">
                        <template scope="scope">
                            <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                            <span v-else>暂无数据</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="pics"
                        align="center"
                        show-overflow-tooltip
                        label="照片">
                        <template scope="scope">
                            <img v-if="scope.row.pics" :src="scope.row.pics.split('|')[0]" @click="$refs.washImages.show(scope.row.pics)">
                            <span v-else="scope.row.pics">暂无照片</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="storageNumber"
                        align="center"
                        show-overflow-tooltip
                        label="存放">
                        <template scope="scope">
                            <span>{{scope.row.storageName}}{{scope.row.storageNumber}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="barCode"
                        align="center"
                        show-overflow-tooltip
                        label="条码号">
                    </el-table-column>
                    <el-table-column
                        prop="flaw"
                        align="center"
                        show-overflow-tooltip
                        label="瑕疵">
                    </el-table-column>
                    <el-table-column
                        prop="accessory"
                        align="center"
                        show-overflow-tooltip
                        label="附件">
                    </el-table-column>
                    <el-table-column
                        prop="remarks"
                        align="center"
                        show-overflow-tooltip
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        show-overflow-tooltip
                        label="操作">
                        <template scope="scope">
                            <div class="btn-box" v-if="order.orderStatus > 3">
                                <el-button type="primary" size="medium" @click="printShuiXiMai(scope.row)">补打水洗唛</el-button>
                                <el-button type="primary" size="medium" style="margin-left: 0px; margin-top: 10px" @click="printZhiJian(scope.row)">{{ order.orderStatus === 4 ? '打印质检单' : '补打质检单' }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!--图片预览-->
        <wash-images ref="washImages"></wash-images>

    </div>
</template>

<script>
import { get, post, put } from '@/utils/request.js';
import WashImages from '@/components/wash/washImages.vue';
export default {
    components:{
        WashImages
    },
    data(){
        return{
            washDetailsVisible: false,
            order: null,
            orderStatusStoreEnumList: [],
            washOrderitemList: [],
        }
    },
    mounted() {
        this.getOrderStautsStoreEnum()
    },
    methods:{
        // 显示窗口
        show(order){
            this.washDetailsVisible = true
            this.order = order
            this.washOrderitemList = []
            this.getWashOrderItemList()
        },

        // 关闭窗口
        close(){
            this.washDetailsVisible = false
            this.order = null
            this.washOrderitemList = []
        },

        // 获取订单状态枚举
        getOrderStautsStoreEnum(){
            get('/mpp/utils/getEnum',{
                enumType: "order_status_store"
            }).then((res)=>{
                if(res.success){
                    this.orderStatusStoreEnumList = res.enumList
                }
            })
        },

        // 获取录入的信息
        getWashOrderItemList(){
            get('/wash/orderitem/findAll', {
                orderId: this.order.id
            }).then((res) => {
                if (res.success) {
                    this.washOrderitemList = res.list;
                }
            });
        },

        // 继续录入
        enterInfo(){
            this.$emit('enterInfo',this.order)
            this.close()
        },

        // 复制文本
        async cpoyInfo(text){
            try {
                await navigator.clipboard.writeText(text);
            } catch (err) {
            }
        },

        // 打印水洗唛
        printShuiXiMai(washOrderItem){
            console.log("washOrderItem",washOrderItem)
            if (window.chrome.webview) {
                let ordercocde = this.order.receiveCode;
                let seq = washOrderItem.seq;
                let total = this.washOrderitemList.length;
                let storeNmae = this.order.store.storeName;
                let storageArea = "Z";
                let storageNumber = washOrderItem.storageNumber;
                let userinfo = `客户:${this.order.user.userNickname}:${this.order.user.userMobile.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2')}`;
                let product = `物件:${washOrderItem.productName ? washOrderItem.productName : '无'}`;
                let addition = `[配件:${washOrderItem.accessory ? washOrderItem.accessory : '无'}]`;
                let flaw = `[瑕疵:${washOrderItem.flaw ? washOrderItem.flaw : '无'}]`;
                window.chrome.webview.postMessage(`printShuiximai(${ordercocde},${seq},${total},${storeNmae},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`);
                console.log(`printShuiximai(${ordercocde},${seq},${total},${storeNmae},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`)
            }else{
                this.$message({
                    message: "请在桌面软件内使用",
                    type: 'error',
                    duration: 2000
                });
            }
        },

        // 打印质检
        printZhiJian(washOrderItem){
            if (window.chrome.webview) {
                let ordercocde = this.order.receiveCode;
                let seq = washOrderItem.seq;
                let total = this.washOrderitemList.length;
                let storageArea = "A";
                let storageNumber = washOrderItem.storageNumber ? washOrderItem.storageNumber : this.$message.error("请先保存信息");
                let userinfo = `客户:${this.order.user.userNickname}:${this.order.user.userMobile.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2')}`;
                let product = `物件:${washOrderItem.productName ? washOrderItem.productName+washOrderItem.color : '无'}`;
                let addition = `[配件:${washOrderItem.accessory ? washOrderItem.accessory : '无'}]`;
                let flaw = `[瑕疵:${washOrderItem.flaw ? washOrderItem.flaw : '无'}]`;

                window.chrome.webview.postMessage(`printBiaoqian(${ordercocde},${seq},${total},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`);
                console.log(`printBiaoqian(${ordercocde},${seq},${total},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`)
            }else{
                this.$message({
                    message: "请在桌面软件内使用",
                    type: 'error',
                    duration: 2000
                });
            }
        },

        // 打印发货单
        printKuaiDi(){
            if (window.chrome.webview) {
                let ordercocde = this.order.receiveCode;
                let seq = this.washOrderitemList.length;
                let total = this.washOrderitemList.length;
                let storeNmae = this.order.store.storeName;
                let userinfo = `${this.order.user.userNickname}:${this.order.user.userMobile.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2')}`;
                let product = `物件:${this.washOrderitemList.map(item=>item.productName).join("|")}`
                window.chrome.webview.postMessage(`printKuaidi(${ordercocde},${seq},${total},${storeNmae},${userinfo},${product})`);
                console.log(`printKuaidi(${ordercocde},${seq},${total},${storeNmae},${userinfo},${product})`)
            }else{
                this.$message({
                    message: "请在桌面软件内使用",
                    type: 'error',
                    duration: 2000
                });
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background-color: #ccc;

    .comp-title {
        width: 100%;
        height: 60px;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .content {
        padding: 5px;

        .order-info{
            position: relative;
            width: 100%;
            min-width: 1520px;
            height: 150px;
            padding: 10px;
            background-color: #fff;

            .fahuo-btn{
                position: absolute;
                bottom: 10px;
                right: 10px;
            }

            span{
                color: #000;
            }

            .info-item{
                display: inline-block;
                width: 33%;
                min-width: 500px;
                color: #999999;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .info-item-remarks{
                width: 100%;
                color: #999999;
            }
        }

        .other-info{
            width: 100%;
            min-width: 1520px;
            height: 90px;
            margin-top: 2px;
            display: flex;

            div{
                position: relative;
                width: 50%;
                min-width: 759px;
                height: 100%;
                padding: 10px;
                background-color: #fff;
                display: flex;
                flex-direction: column;

                span{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .copy-btn{
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    color: #3e8df7;
                    cursor: pointer;
                }
            }

            :first-child{
                margin-right: 2px;
            }

        }
    }
}

.btn-box {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;

    div {
        background-color: #409eff;
        border-radius: 3px;
        cursor: pointer;
        padding: 0 5px;
        margin: 2px;
        color: #fff;
        font-size: 14px;
    }
}

.table-info{
    height: calc(100vh - 60px - 150px - 90px - 16px);
}
</style>